import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	emailConfiguration: null,
	error: "",
	loading: false,
};
export const addEmailConfiguration = createAsyncThunk(
	"emailConfiguration/addEmailConfiguration",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `emailConfiguration`,
				data: {
					...values,
				},
			});
			toast.success("Email Configuration added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			if (
				error.response &&
				error.response.data &&
				error.response.data.message
			) {
				toast.error(error.response.data.message);
			} else {
				toast.error("Error in adding email configuration . Please try again.");
			}
			console.error(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const sendTestEmail = createAsyncThunk(
	"emailConfiguration/sendTestEmail",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `emailConfiguration/sendTestEmail`,
				data: {
					...values,
				},
			});
			toast.success("Email Send successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			if (
				error.response &&
				error.response.data &&
				error.response.data.message
			) {
				toast.error(error.response.data.message);
			} else {
				toast.error("Error in sending email. Please try again.");
			}
			console.error(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const loadEmailConfig = createAsyncThunk(
	"emailConfig/loadEmailConfig",
	async () => {
		try {
			const data = await axios.get(`emailConfiguration`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);
const emailConfigurationSlice = createSlice({
	name: "emailConfiguration",
	initialState,
	reducers: {
		clearEmailConfiguration: (state) => {
			state.emailConfiguration = null;
		},
	},
	extraReducers: (builder) => {

		// 1) ====== builders for addEmailConfiguration  ======
		builder.addCase(addEmailConfiguration.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addEmailConfiguration.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addEmailConfiguration.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

        // 2) ====== builders for loadEmailConfig ======

		builder.addCase(loadEmailConfig.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadEmailConfig.fulfilled, (state, action) => {
			state.loading = false;
			state.emailConfig = action.payload.data;
		});

		builder.addCase(loadEmailConfig.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

        // 3) ====== builders for sendTestEmail  ======
		builder.addCase(sendTestEmail.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(sendTestEmail.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(sendTestEmail.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default emailConfigurationSlice.reducer;
export const { clearEmailConfiguration } = emailConfigurationSlice.actions;
